import {
  httpApps,
  httpAdminCompanyLocation,
  httpDealer,
} from "../helper/http-common";

class SelectYourDiamoiondServices {
  GetRingBuilderOpeningPage(inputData) {
    return httpApps.post(
      "PendantBuilder/GetPendentBuilderOpeningPage",
      inputData
    );
  }
  PendantBuilderLoadDiamonds(inputData) {
    return httpApps.post(
      "PendantBuilder/PendantBuilderLoadDiamonds",
      inputData
    );
  }
  LoadCompareDiamondsList(inputData) {
    return httpApps.post("PendantBuilder/LoadCompareDiamondsList", inputData);
  }

  PendantBuilderLabGrownDiamonds(inputData) {
    return httpApps.post(
      "PendantBuilder/PendantBuilderLabGrownDiamonds",
      inputData
    );
  }

  GetAvailablePendantbuilderFilters(inputData) {
    return httpApps.post(
      "PendantBuilder/GetAvailablePendantbuilderFilters",
      inputData
    );
  }

  SendMailToRetailerForNoResults(inputData) {
    return httpApps.post(
      "PendantBuilder/SendMailToRetailerForNoResults",
      inputData
    );
  }
  GetRingBuilderMinedCompareData(inputData) {
    return httpApps.post(
      "RingBuilder/GetRingBuilderMinedCompareData",
      inputData
    );
  }

  GetRingBuilderLabCompareData(inputData) {
    return httpApps.post("RingBuilder/GetRingBuilderLabCompareData", inputData);
  }

  RingBuilderRequestCertificate(inputData) {
    return httpApps.post(
      "RingBuilder/RingBuilderRequestCertificate",
      inputData
    );
  }

  GetDealerInformation(inputData) {
    return httpApps.post("DiamondLink/GetDealerInformation", inputData);
  }

  GetSimilarDiamondsByPage(inputData, pageName) {
    if (pageName == "Mined") {
      return httpApps.post(
        "PendantBuilder/PendantBuilderLoadDiamonds",
        inputData
      );
    } else {
      return httpApps.post(
        "PendantBuilder/PendantBuilderLabGrownDiamonds",
        inputData
      );
    }
  }

  GetRingBuilderViewDetailsMineLabDiamond(inputData) {
    return httpApps.post("PendantBuilder/PendantBuilderGetData", inputData);
  }

  GetDealerLocationData(inputData) {
    return httpApps.post("DiamondLink/GetDealerLocationData", inputData);
  }
  GetsPendantBuilderOptiondetails(inputData) {
    return httpApps.post(
      "PendantBuilder/GetsPendantBuilderOptiondetails",
      inputData
    );
  }
  GetLocationDetails(inputData) {
    return httpAdminCompanyLocation.post(
      "/Profile/LocationLoadDetailsForML",
      inputData
    );
  }
  
  GetLocationByID(inputData) {
    return httpAdminCompanyLocation.post(
      "/Profile/LocationByID",
      inputData
    );
  }

  ProductTracking(inputData) {
    return httpApps.post("DiamondLink/ProductTracking", inputData);
  }
  DiamondTracking(inputData) {
    return httpApps.post("DiamondLink/DiamondTracking", inputData);
  }
  GetMenuList(inputData) {
    return httpAdminCompanyLocation.post("/Tools/GetMenuListForML", inputData);
  }
  CompanyWhileLabel() {
    return httpDealer.get("/Dashboard/CompanyWhileLabelForML");
  }
  GetLanguage(inputData) {
    return httpAdminCompanyLocation.post(
      "/SelectLenguage/SelectlanguageForDelarForML",
      inputData
    );
  }

  GetOptionsDetails(inputData) {
    return httpApps.post("DiamondLink/GetOptionsDetails", inputData);
  }
}

export default new SelectYourDiamoiondServices();
